export const role = {
	GET: "role/get",
}

export default role
